import React from 'react'
import FaPrint from 'react-icons/lib/fa/print';
import { useSelector, useDispatch } from 'react-redux'
import actions from '../../state/roster/actions'
import types from '../../state/roster/constants'
import './BatchPrintButton.scss'
import { useTranslation } from 'react-i18next';

// bulk print utility button

export default function PrintButton() {

    const isEnabled = useSelector(state => state.reports.roster.batchPrint)
    const dispatch = useDispatch()

    const {t} = useTranslation("reports")

    const path = window.location.pathname
    // assumes the report name is in the last segment of the path as it is currently
    const reportName = path.split('/').pop()
    const isBatchPrintReport = ['parent', 'readingrope', 'progress'].includes(reportName);
    if (!isBatchPrintReport) return null

    let className = 'printButton'
    if (isEnabled) className += ' active'
    
    return (
        <div className="batchPrintButtonContainer">
            <button className={className} onClick={onClickPrint}>
                <FaPrint size="18" className='printButtonIcon' />{t("Batch Print")}
            </button>
        </div> );

    function onClickPrint() {
        if (!isEnabled) dispatch(actions[types.BATCH_PRINT](true))
        else dispatch(actions[types.BATCH_PRINT](false))
    }
}